"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendInfoReport = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const _params_1 = require("@params");
const uiConfigs_1 = require("@app/utils/uiConfigs");
const sendInfoReport = (info_reps, ex_id, userId, checkedAnsweredData) => {
    const answeredData = checkedAnsweredData === null || checkedAnsweredData === void 0 ? void 0 : checkedAnsweredData.filter(item => item === null || item === void 0 ? void 0 : item.isChecked);
    const correctAnswerCount = answeredData === null || answeredData === void 0 ? void 0 : answeredData.filter(item => item === null || item === void 0 ? void 0 : item.isCorrect);
    const unCorrectAnswerCount = answeredData === null || answeredData === void 0 ? void 0 : answeredData.filter(item => !(item === null || item === void 0 ? void 0 : item.isCorrect) && (item === null || item === void 0 ? void 0 : item.isChecked));
    let cumulativeSum = 0;
    const final_result = {
        "percent_category": ((correctAnswerCount === null || correctAnswerCount === void 0 ? void 0 : correctAnswerCount.length) / (answeredData === null || answeredData === void 0 ? void 0 : answeredData.length)) * 100,
        "percent_errors": 100 - ((correctAnswerCount === null || correctAnswerCount === void 0 ? void 0 : correctAnswerCount.length) / (answeredData === null || answeredData === void 0 ? void 0 : answeredData.length)) * 100,
        count_replays: answeredData === null || answeredData === void 0 ? void 0 : answeredData.length,
        finished: 1
    };
    const newInfoReps = info_reps === null || info_reps === void 0 ? void 0 : info_reps.map((item, idx) => {
        const newSystemTime = cumulativeSum;
        cumulativeSum += (item === null || item === void 0 ? void 0 : item.system_time) || 0;
        const { startTime: _ } = item, newData = __rest(item, ["startTime"]);
        return Object.assign(Object.assign({}, newData), { system_time: newSystemTime, local_errors: [{ "0": 1 }], category_name: (newData === null || newData === void 0 ? void 0 : newData.category_name)
                ? newData === null || newData === void 0 ? void 0 : newData.category_name
                : uiConfigs_1.categoryIds[uiConfigs_1.categoriesName.incorrect], rep_id: idx + 1 });
    });
    const dataForSendBackend = {
        "user": { "id": userId },
        "exercise": {
            "abort_exercise": {},
            "final_result": final_result,
            "info_reps": newInfoReps,
            "id": ex_id
        }
    };
    return fetch(`${_params_1.apiHost}/exercise_report`, {
        method: "POST",
        body: JSON.stringify(dataForSendBackend),
        headers: {
            "Content-Type": "application/json",
            "jwt": "ezspeech!11",
            "X-CSRFToken": js_cookie_1.default.get("csrftoken")
        }
    });
};
exports.sendInfoReport = sendInfoReport;
